module.exports = __webpack_public_path__ + "static/img/white-student.91eb8de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invitation/white-student.png
// module id = zHOO
// module chunks = 2